import gameObjectTypes from './gameObjectTypes';

export default [
    gameObjectTypes.DIVIDE_LINE,
    gameObjectTypes.CURBSTONE_SEPARATOR_LEFT,
    gameObjectTypes.CURBSTONE_SEPARATOR_RIGHT,
    gameObjectTypes.HUMMOCK_1_LEFT,
    gameObjectTypes.HUMMOCK_1_RIGHT,
    gameObjectTypes.BUSH_1_LEFT,
    gameObjectTypes.BUSH_1_RIGHT,
    gameObjectTypes.BUSH_2_LEFT,
    gameObjectTypes.BUSH_2_RIGHT,
    gameObjectTypes.BUSH_3_LEFT,
    gameObjectTypes.BUSH_3_RIGHT,
    gameObjectTypes.SIGN_60_LEFT,
    gameObjectTypes.SIGN_60_RIGHT,
    gameObjectTypes.SIGN_MOOSE_LEFT,
    gameObjectTypes.SIGN_MOOSE_RIGHT,
    gameObjectTypes.SPRUCE_1_LEFT,
    gameObjectTypes.SPRUCE_1_RIGHT,
    gameObjectTypes.SPRUCE_2_LEFT,
    gameObjectTypes.SPRUCE_2_RIGHT,
    gameObjectTypes.TREE_1_LEFT,
    gameObjectTypes.TREE_1_RIGHT,
    gameObjectTypes.MOOSE_LEFT,
    gameObjectTypes.MOOSE_RIGHT,
    gameObjectTypes.ROCK_1_LEFT,
    gameObjectTypes.ROCK_1_RIGHT,
    gameObjectTypes.REGION_LAKE,
    gameObjectTypes.REGION_1_SIGN,
    gameObjectTypes.REGION_1_BUILDING,
    gameObjectTypes.REGION_2_SIGN,
    gameObjectTypes.REGION_3_SIGN,
    gameObjectTypes.REGION_3_BUILDING,
    gameObjectTypes.REGION_4_SIGN,
    gameObjectTypes.REGION_5_SIGN,
    gameObjectTypes.REGION_5_BUILDING,
    gameObjectTypes.REGION_6_SIGN
];
